<mat-chip-listbox #chipGrid aria-label="Group selection">
  @for (group of candidateGroups(); track group) {
  <mat-chip class="bg-primary" (removed)="remove(group)">
    {{ group.name }}
    <button matChipRemove [attr.aria-label]="'remove ' + group">
      <span class="material-symbols-outlined fs-6"> close </span>
    </button>
  </mat-chip>
  }
</mat-chip-listbox>
<mat-form-field class="w-100">
  <mat-label class="mb-2">Attribuer un groupe</mat-label>
  <input
    type="text"
    placeholder="Choisir un groupe"
    aria-label="Number"
    matInput
    #groupInput
    [formControl]="groupControl"
    [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="groupSelected($event)">
    @for (group of filteredGroupsSummary | async; track group) {
    <mat-option [value]="group">
      {{ group.name }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
